import { createContext } from 'react';

const ConfirmationContext = createContext({
  openConfirmation: () => ({
    handleAgree: () => null,
    handleClose: () => null,
    title: '',
    desc: '',
    cancelText: '',
    confirmText: '',
    maxWidth: '',
    minWidth: '',
    noCancel: false,
    direction: 'column',
  }),
  closeConfirmation: () => null,
});

export default ConfirmationContext;
